import styled from "styled-components";
import { Link } from "react-router-dom";
import { routes } from "common/routes";

const Logo = styled.h1`
  display: flex;
  align-items: center;
  font-size: 20px;
  font-style: italic;
  font-weight: bold;
  height: 4rem;
  margin: 0;
`;

const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  
  &:hover {
    color: inherit;
  }
`;

export const AppLogo = () => (
  <StyledLink to={routes.HOME}>
    <Logo>Handpickd</Logo>
  </StyledLink>
);
